<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		Button,
		ButtonGroup,
		Container,
		IconButton,
		Popover,
		Text,
	} from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let isMobile = false,
		infoText = '',
		activeButtonTab: boolean = false,
		scrollPaddings: boolean = false;

	let popover = false;
</script>

<Container padding={scrollPaddings ? 'scrollPaddings' : '0'}>
	<div class="d-flex align-items-center">
		<Text class="mr-xs" styleType="h2"
			>{$format('schedule_mode_selection', { default: 'Mode selection' })}</Text
		>
		<Popover
			hideCloseBtn
			show={popover}
			placement="top"
			type="hover"
			on:close={() => (popover = false)}
		>
			<IconButton
				on:click={() => {
					popover = true;
				}}
				icon="fa-solid fa-circle-info"
				variant="help"
				aria-label={$format('schedule_mode_selection_info', {
					default: 'Mode selection info',
				})}
			/>
			<svelte:fragment slot="customContent">
				<Text styleType="body-small">{infoText}</Text>
			</svelte:fragment>
		</Popover>
	</div>

	<ButtonGroup
		id="buttongroup-5gjke1o"
		class={classMap({ 'mt-s': true, 'width-full d-flex': isMobile })}
		aria-label={$format('schedule_mode_selection', { default: 'Mode selection' })}
	>
		<Button
			class={classMap({
				active: !activeButtonTab,
				'flex-1': isMobile,
			})}
			size="m"
			on:click={() => (activeButtonTab = false)}
		>
			{$format('schedule_simple_mode', {
				default: 'Simple',
			})}
		</Button>
		<Button
			class={classMap({
				active: activeButtonTab,
				'flex-1': isMobile,
			})}
			size="m"
			on:click={() => (activeButtonTab = true)}
		>
			{$format('schedule_advanced_mode', {
				default: 'Advanced',
			})}
		</Button>
	</ButtonGroup>
</Container>
